import { render, staticRenderFns } from "./RegisterJWT.vue?vue&type=template&id=1fde5dee&scoped=true"
import script from "./RegisterJWT.vue?vue&type=script&lang=js"
export * from "./RegisterJWT.vue?vue&type=script&lang=js"
import style0 from "./RegisterJWT.vue?vue&type=style&index=0&id=1fde5dee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fde5dee",
  null
  
)

export default component.exports